export const LIGHTEN = 0.005;
export const DARKEN = 0.07;
export const BORDER_RADIUS_SMALL = 4;
export const BORDER_RADIUS_X_SMALL = 2;
export const BORDER_RADIUS = 8;
export const BORDER_RADIUS_LARGE = 12;
export const SCROLL_WIDTH = 8
